import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import PickupForm from 'common/components/address/PickupForm';
import PickupLocationForm from 'common/components/address/PickupLocationForm';
import { initialFormValues } from 'common/components/address/helpers';
import { FormError } from 'common/components/layout';
import {
  getDefaultCountryCode,
  getOperatingCountryCodes,
  getCartTitle
} from 'common/helpers/miscHelper';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { phoneFormatForDB, phoneFormat } from 'common/helpers/phoneHelper';
import { updateCart } from 'redux/cart/actions';
import { listPickupLocations } from 'redux/inventoryLocations/actions';

import CustomerDisplay from './components/CustomerDisplay';
import RombauerPickupBy from './components/RombauerPickupBy';
import { validateForLoggedInCustomerPickup } from './validators';

class Customer extends Component {
  componentDidMount() {
    const { props } = this;
    props.listPickupLocations();
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    const cart = {
      pickupBy: data,
      orderDeliveryMethod: 'Pickup',
      giftMessage: null,
      shippingInstructions: null
    };
    if (form['pickup-by']) {
      cart.metaData = {
        'pickup-by': form['pickup-by']
      };
    }
    const successFunction = () => {
      props.onEdit('shipping');
    };
    props.updateCart(cart, successFunction);
  };

  handleShip = (e) => {
    e.preventDefault();
    const { onShip } = this.props;
    onShip();
  };

  render() {
    const { cart, customer, handleSubmit, form, settings } = this.props;
    const { inventoryLocation, formValues } = this.props;
    if (!inventoryLocation.data || !formValues) {
      return null;
    }
    let object = cart.shipTo;
    if (!object) {
      object = { countryCode: getDefaultCountryCode(settings) };
    }
    if (getOperatingCountryCodes(settings).length === 1) {
      object.countryCode = getDefaultCountryCode(settings);
    }
    const title = getCartTitle(settings);

    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <CustomerDisplay customer={customer.data} />
        <p>&nbsp;</p>
        <div className="c7-checkout__content__title">
          <h3>Pickup By</h3>
          <a
            className="c7-checkout__content__title__ship"
            onClick={this.handleShip}
          >
            I prefer to have my order shipped
          </a>
        </div>
        <PickupForm />
        <h3>Pickup At</h3>
        <PickupLocationForm
          formValues={formValues}
          inventoryLocation={inventoryLocation}
        />
        <RombauerPickupBy />

        <div className="c7-checkout__content__buttons">
          <button className="c7-button" type="submit">
            Continue to payment method
          </button>
          <a href="/cart">Return to {title.toLowerCase()}</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values) => {
  const data = {
    firstName: values.firstName,
    lastName: values.lastName,
    phone: phoneFormatForDB(values.phone, values.countryCode),
    countryCode: values.countryCode,
    inventoryLocationId: values.inventoryLocationId
  };
  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values);
  data.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  data.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  data.birthYear = values.birthYear && convertStringToInteger(values.birthYear);
  const errors = validateForLoggedInCustomerPickup(data, ownProps.settings);
  return errors;
};

const getFirstInventoryLocation = (inventoryLocation) => {
  if (!inventoryLocation || !inventoryLocation.data) {
    return null;
  }
  const inventoryLocationIdArray = Object.keys(inventoryLocation.data);

  return inventoryLocationIdArray[0];
};

const mapStateToProps = (state, ownProps) => {
  const { shipTo, pickupBy, metaData } = ownProps.cart;
  const { customer } = state;

  let initialValues;
  if (pickupBy) {
    initialValues = initialFormValues(pickupBy);
    if (metaData?.['pickup-by']) {
      initialValues['pickup-by'] = metaData['pickup-by'];
    }
  } else if (shipTo) {
    initialValues = initialFormValues(shipTo);
  } else {
    initialValues = initialFormValues(customer.data);
    if (customer.data.phones.length) {
      initialValues.phone = phoneFormat(
        customer.data.phones[0].phone,
        customer.data.countryCode
      );
    }
  }
  if (!initialValues.countryCode) {
    initialValues.countryCode = customer.data.countryCode;
  }
  if (!initialValues.inventoryLocationId) {
    initialValues.inventoryLocationId = getFirstInventoryLocation(
      state.inventoryLocation
    );
  }
  return {
    customer: state.customer,
    settings: state.setting,
    inventoryLocation: state.inventoryLocation,
    formValues:
      state.form.customerLoggedInPickup &&
      state.form.customerLoggedInPickup.values,
    initialValues
  };
};

Customer = reduxForm({
  form: 'customerLoggedInPickup',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Customer);

export default connect(mapStateToProps, {
  listPickupLocations,
  updateCart
})(Customer);
